import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { history } from 'redux/store';
import { updatePageStatus } from 'redux/actions/ui.action';
import background from 'static/svg/bg-topic-detail.svg';
import unverified from 'static/images/mvp/unverified.png';
import verifying from 'static/images/mvp/verifying.png';
import rejected from 'static/images/mvp/rejected.png';
import qrVerify from 'static/images/mvp/qr_verify_ced.png';
import Section from 'views/components/core/Section';
import './custom-home.scss';
import CardMvpSession from '../../components/core/CardSession';
import Auth from '@aws-amplify/auth';
import ReactGA from 'react-ga';
import { Modal as ModalPopup } from 'react-bootstrap';

import { getSessions, getMySessions, getCategorySessions, getListBuddyRole, getMyTopics, getListDurationByLevel, fetchNeedEvaluateSessions } from 'redux/actions/mvp/session.action';
import { PageHero, PageLoader } from '@kambria/kambria-lego';

import config from 'config';
import Pagination from '../../components/core/Pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { ConfigProvider, DatePicker, Select } from 'antd';
import en_US from 'antd/es/locale/en_US';
import vi_VN from 'antd/es/locale/vi_VN';
import moment from 'moment/moment';
import debounce from 'lodash/debounce';
import _ from 'lodash';
import { I18n } from '../../../helpers/i18n';
import removeSessionImage from '../../../static/images/mvp/remove-session.png';
import RatingFloatNotification from '../../components/core/RatingFloatNotification';

const locale = I18n.language === 'vi' ? vi_VN : en_US;

class Home extends React.Component {
  constructor() {
    super();

    this.state = {
      visibleMembershipModal: false,
      currentPage: 1,
      totalRecords: 0,
      pageLimit: 12,
      listSessions: [],
      showVerifyModal: false,
      exploreSessions: [],
      filterKeySearch: '',
      categories: [],
      categoriesLevel1: [],
      categoriesLevel2: [],
      roles: [],
      filterCategories: [],
      filterCategoryLevel1: null,
      filterCategoryLevel2: [],
      rawCategoryLevel2: null,
      filterEvaluating: [],
      filterRole: null,
      filterCreateDate: null,
      filterLanguage: [],
      filterDuration: null,
      durations: [],
      openFilterCreateDate: false,
      startDate: null,
      endDate: null,
      evaluating: [],
      createDate: [],
      languages: [],
      currentI18nLanguage: I18n.language || 'vi',
      isChangingCategoryLevel1: false,
      // My Topics state for guide
      listMyTopics: [],
      currentPageMyTopics: 1,
      totalRecordsMyTopics: 0,
      pageLimitMyTopics: 12,
      // My Topics filters
      filterKeySearchMyTopics: '',
      filterCategoryLevel1MyTopics: null,
      filterCategoryLevel2MyTopics: [],
      categoriesLevel2MyTopics: [],
      filterLanguageMyTopics: [],
      filterCreateDateMyTopics: null,
      startDateMyTopics: null,
      endDateMyTopics: null,
      openFilterCreateDateMyTopics: false,
      // filterRatingMyTopics: null,
      // ratingOptionsMyTopics: [],
      // My Sessions state for guide - REMOVED
      pendingRatingSession: null,
    };
    this._isMounted = false;
    this._timeouts = [];
    this._selectRefs = [];
  }

  style = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  };

  openMembershipModal = () => {
    if (this._isMounted && (!localStorage.getItem('ced:popupModal') || localStorage.getItem('ced:popupModal') === 'true')) {
      this.safeSetState({ visibleMembershipModal: true });
      localStorage.setItem('ced:popupModal', 'true');
    }
  };

  openVerifyModal = () => {
    if (this._isMounted) {
      this.safeSetState({ showVerifyModal: true });
    }
  };

  closeVerifyModal = () => {
    if (this._isMounted) {
      this.safeSetState({ showVerifyModal: false });
    }
  };

  // Safe setState that checks if component is still mounted
  safeSetState = (state, callback) => {
    if (this._isMounted) {
      // Double check before actually calling setState
      if (this._isMounted) {
        this.setState(state, callback);
      }
    }
  };

  // Helper to create timeout that will be cleaned up
  createTimeout = (callback, delay) => {
    const timeoutId = setTimeout(() => {
      if (this._isMounted) {
        callback();
      }
    }, delay);
    this._timeouts.push(timeoutId);
    return timeoutId;
  };

  componentWillUnmount() {
    this._isMounted = false;
    // Clear all timeouts
    this._timeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this._timeouts = [];
    // Cancel debounced function
    if (this.handleChangeDebounced && this.handleChangeDebounced.cancel) {
      this.handleChangeDebounced.cancel();
    }
    if (this.handleChangeDebouncedMyTopics && this.handleChangeDebouncedMyTopics.cancel) {
      this.handleChangeDebouncedMyTopics.cancel();
    }
    // Force close all Select dropdowns and cleanup refs
    if (this._selectRefs) {
      this._selectRefs.forEach(ref => {
        if (ref) {
          try {
            // Force blur to close dropdown
            if (ref.blur) {
              ref.blur();
            }
            // Try to close dropdown via antd Select API
            const selectElement = ref.rcSelect || ref;
            if (selectElement) {
              // Use antd Select's internal methods to close dropdown
              if (selectElement.setOpen && typeof selectElement.setOpen === 'function') {
                selectElement.setOpen(false);
              } else if (selectElement.setState && typeof selectElement.setState === 'function') {
                // Fallback: try to set state directly (may not work in newer antd versions)
                try {
                  selectElement.setState({ open: false });
                } catch (e) {
                  // Ignore if setState is not available
                }
              }
            }
          } catch (e) {
            // Ignore errors during cleanup
          }
        }
      });
      this._selectRefs = [];
    }
    // Force close any remaining Select dropdowns via DOM
    try {
      // Close all visible antd Select dropdowns
      const allDropdowns = document.querySelectorAll('.ant-select-dropdown:not(.ant-select-dropdown-hidden)');
      allDropdowns.forEach(dropdown => {
        dropdown.classList.add('ant-select-dropdown-hidden');
        // Also set display none to ensure it's hidden
        if (dropdown.style) {
          dropdown.style.display = 'none';
        }
      });
      // Remove any Select overlay from DOM to prevent state updates
      const selectOverlays = document.querySelectorAll('.rc-select-dropdown');
      selectOverlays.forEach(overlay => {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      });
      // Also remove antd Select dropdowns from DOM
      const antdDropdowns = document.querySelectorAll('.ant-select-dropdown');
      antdDropdowns.forEach(dropdown => {
        if (dropdown.parentNode && dropdown.parentNode !== document.body) {
          // Only remove if not directly in body (antd might manage it)
          try {
            dropdown.parentNode.removeChild(dropdown);
          } catch (e) {
            // Ignore if already removed
          }
        }
      });
    } catch (e) {
      // Ignore errors during cleanup
    }
  }

  async componentDidMount() {
    this._isMounted = true;
    this._selectRefs = [];
    document.title = `CED - ${I18n.t('ced_title')}`;
    this.props.updatePageStatus('loading');
    const { getSessions, getMySessions, getCategorySessions, getListBuddyRole, getListDurationByLevel, user } = this.props;

    // Xóa page và limit khỏi URL nếu có trong query string
    const searchParams = new URLSearchParams(this.props.location?.search || '');
    if (searchParams.has('page') || searchParams.has('limit')) {
      searchParams.delete('page');
      searchParams.delete('limit');
      const newSearch = searchParams.toString();
      if (this.props.history?.replace) {
        this.props.history.replace({
          pathname: this.props.location?.pathname || '/',
          search: newSearch ? `?${newSearch}` : ''
        });
      }
    }

    // Initialize filter options - set rating options immediately
    const ratingOptions = [
      { value: 1, key: 1, label: I18n.t('from_one_star') },
      { value: 2, key: 2, label: I18n.t('from_two_star') },
      { value: 3, key: 3, label: I18n.t('from_three_star') },
      { value: 4, key: 4, label: I18n.t('from_four_star') },
      { value: 5, key: 5, label: I18n.t('five_star') },
    ];

    this.createTimeout(() => {
      this.safeSetState({
        evaluating: [], //ratingOptions,
        ratingOptionsMyTopics: [], //ratingOptions,
        createDate: [
          { value: 'today', label: I18n.t('today') },
          { value: 'yesterday', label: I18n.t('yesterday') },
          { value: 'thisWeek', label: I18n.t('this_week') },
          { value: 'sevenDaysAgo', label: I18n.t('7_days_ago') },
          { value: 'other', label: I18n.t('range_calendar') },
        ]
      });
    }, 0);

    // Load filter options
    const params = this.mapUrlToFilter();
    const newState = {
      ratingOptionsMyTopics: [], //ratingOptions,
    };

    // Load languages
    if (this.props.listLanguage?.length) {
      const currentLanguage = I18n.language || 'vi';
      // Map language labels according to current website language
      newState.languages = this.props.listLanguage.map(item => {
        let label = item.label;
        // If current website language is Vietnamese, show Vietnamese labels
        if (currentLanguage === 'vi') {
          label = item.value === 'vi' ? 'Tiếng Việt' : 'Tiếng Anh';
        } else {
          // If current website language is English, show English labels
          label = item.value === 'en' ? 'English' : 'Vietnamese';
        }
        return {
          key: item.value,
          value: item.value,
          label: label,
        };
      });
      // Default: select all languages
      if (newState.languages.length > 0) {
        newState.filterLanguage = newState.languages;
      }
    }

    // Load categories, roles, and durations
    let categories = [], roles = [], durations = [];
    [categories, roles, durations] = await Promise.all([
      getCategorySessions(),
      getListBuddyRole(),
      getListDurationByLevel(),
    ]);

    // Check if component is still mounted after async operations
    if (!this._isMounted) {
      return;
    }

    // Process durations - API returns { status: 'OK', data: [...] }
    const durationsData = durations?.data || durations || [];
    const durationsOptions = durationsData.map(item => ({
      key: item.value,
      value: item.value,
      label: `${item.value} ${I18n.t('minutes')}`,
    }));
    newState.durations = durationsOptions;

    // Process categories
    // API already returns name in the correct language based on accept-language header
    const categoriesLevel1 = categories?.map(item => ({
      key: item._id,
      value: item._id,
      label: this.getCategoryLabel(item),
    })) || [];

    const categoriesWithChildren = categories || [];

    newState.sharingTopicsCategories = [];
    newState.sharingTopicsCategoriesLevel1 = [];


    const { categoryId, categoryLevel1, categoryLevel2, evaluating, keySearch, startDate, endDate, role, language } = params;

    // Handle language filter from URL
    if (language && newState.languages) {
      const languageIds = language.split(',');
      const languageOptions = newState.languages.filter(lang => languageIds.includes(lang.value));
      if (languageOptions.length > 0) {
        newState.filterLanguage = languageOptions;
      }
    }

    // Handle category filters - map categoryLevel1/categoryLevel2 to categoryId for API
    if (categoryLevel1) {
      const selectedCategory = categoriesWithChildren.find(cat => cat._id === categoryLevel1);
      if (selectedCategory) {
        newState.filterCategoryLevel1 = categoriesLevel1.find(cat => cat.key === categoryLevel1);
        if (selectedCategory.children) {
          const categoriesLevel2 = selectedCategory.children.map(child => ({
            key: child._id,
            value: child._id,
            label: this.getCategoryLabel(child),
          }));
          newState.categoriesLevel2 = categoriesLevel2;

          if (categoryLevel2 && categoryLevel2.trim() !== '') {
            const level2Ids = categoryLevel2.split(',');
            newState.filterCategoryLevel2 = categoriesLevel2.filter(child => level2Ids.includes(child.key));
          } else {
            // Default: select all level 2
            newState.filterCategoryLevel2 = categoriesLevel2;
          }
        }
      }
    } else if (categoryId) {
      const cateIds = categoryId.split(',');
      const cateInfo = categoriesLevel1.filter(obj => cateIds.includes(obj.key));
      newState.filterCategories = cateInfo;
    }

    if (evaluating) {
      const fEvaluating = evaluating.split(',');
      const evaluatingOptions = [
        { value: 1, key: 1, label: I18n.t('from_one_star') },
        { value: 2, key: 2, label: I18n.t('from_two_star') },
        { value: 3, key: 3, label: I18n.t('from_three_star') },
        { value: 4, key: 4, label: I18n.t('from_four_star') },
        { value: 5, key: 5, label: I18n.t('five_star') },
      ];
      const data = evaluatingOptions.filter(obj => fEvaluating.includes(String(obj.key)));
      newState.filterEvaluating = data;
    }

    if (role) {
      const data = roles.filter(obj => obj.value === role);
      newState.filterRole = data.length > 0 ? data[0] : null;
    }

    if (keySearch) {
      newState.filterKeySearch = keySearch;
    }

    if (startDate || endDate) {
      this.handleSelectCreateDate({ value: 'other', label: I18n.t('range_calendar'), key: 'other' });
      if (startDate) this.handleStartTime(moment(Number(startDate)));
      if (endDate) this.handleEndTime(moment(Number(endDate)));
    }

    newState.categories = categoriesLevel1;
    newState.categoriesLevel1 = categoriesLevel1;
    newState.categoriesWithChildren = categoriesWithChildren;
    newState.roles = roles;

    // Double check before setting state
    if (!this._isMounted) {
      return;
    }

    this.safeSetState(newState, () => {
      if (!this._isMounted) {
        return;
      }
      // Đảm bảo update label sau khi DOM đã render
      this.createTimeout(() => {
        if (this._isMounted && this.state.filterLanguage && this.state.filterLanguage.length > 0) {
          this.updateFilterLabel('filterLanguage', I18n.t('language'));
        }
        if (this._isMounted && this.state.filterCategoryLevel2 && this.state.filterCategoryLevel2.length > 0) {
          this.updateFilterLabel('filterCategoryLevel2', I18n.t('session_category_level2'));
        }
      }, 100);
    });

    // Fetch explore sessions if user is Explorer (senior, explorer, or both)
    // Check cả user.type, user.mvpUserType, và localStorage
    const userStorage = localStorage.getItem('ced:user-info');
    const userTypeFromState = user?.type || user?.mvpUserType;
    let userTypeFromStorage = null;
    if (userStorage) {
      try {
        const parsed = JSON.parse(userStorage);
        userTypeFromStorage = parsed?.type || parsed?.mvpUserType;
      } catch (e) {
        // ignore
      }
    }
    const userType = userTypeFromState || userTypeFromStorage;
    const isExplorer = userType === 'senior' || userType === 'explorer' || userType === 'both';
    const isGuide = userType === 'guide';

    let exploreSessions = [];
    if (user && isExplorer) {
      // Lấy ngôn ngữ hiện tại từ localStorage hoặc I18n
      const currentLanguage = localStorage.getItem('ced:language') || I18n.language || 'vi';

      const mySessions = await getMySessions({
        status: 'is_processing,confirm',
        limit: 10,
        language: currentLanguage
      });

      if (mySessions.success && mySessions.data && mySessions.data.data) {
        const allSessions = mySessions.data.data.list || [];
        const now = Date.now();

        // Filter chỉ lấy upcoming (startTime > now) và ongoing (startTime <= now && endTime >= now)
        // Loại bỏ các session đã kết thúc (endTime < now) hoặc có state = 'is_ended'
        exploreSessions = allSessions.filter(session => {
          if (!session.startTime || !session.endTime) {
            return false;
          }
          const startTime = Number(session.startTime);
          const endTime = Number(session.endTime);

          // Loại bỏ session đã kết thúc (endTime < now)
          if (endTime < now) {
            return false;
          }

          // Loại bỏ session có state = 'is_ended'
          if (session.state === 'is_ended') {
            return false;
          }

          // Loại bỏ session có status = 'reject' hoặc state = 'reject'
          if (session.status === 'reject' || session.state === 'reject') {
            return false;
          }

          // Upcoming: chưa bắt đầu (startTime > now)
          const isUpcoming = startTime > now;
          // Ongoing: đang diễn ra (startTime <= now && endTime >= now)
          const isOngoing = startTime <= now && endTime >= now;
          const shouldShow = isUpcoming || isOngoing;

          return shouldShow;
        });
      }
    } else if (user && isGuide) {
      // For guide user, fetch both My Topics and My Sessions
      await this.fetchMyTopicsForGuide();
      // Update page status to loaded after fetching topics and sessions
      if (this._isMounted) {
        this.props.updatePageStatus('loaded');
      }
      return; // fetchMyTopicsForGuide and fetchMySessionsForGuide will update state, so we can return early
    }

    // Fetch popular topics sessions with filters - chỉ fetch nếu user không phải là guide
    if (!isGuide) {
      // Sử dụng giá trị mặc định page = 1, limit = 12 (không đọc từ URL)
      const filterParams = this.buildFilterParams(newState, 1);
      const sessions = await getSessions(filterParams);

      if (this._isMounted && sessions.success) {
        const data = sessions.data.data;
        const listSessions = data.list || [];
        this.safeSetState({
          listSessions,
          currentPage: data.currentPage || 1,
          totalRecords: Number(data.total) || 0,
          exploreSessions,
        });
      } else if (this._isMounted) {
        // Khi API fails hoặc không có data, vẫn set listSessions là empty array để hiển thị empty state
        this.safeSetState({
          listSessions: [],
          currentPage: 1,
          totalRecords: 0,
          exploreSessions
        });
      }
    } else {
      // Nếu là guide, fetch My Topics và chỉ set exploreSessions, không set listSessions
      const { getMyTopics } = this.props;

      // Load filter từ URL cho My Topics
      const params = this.mapUrlToFilter();
      const { categoryLevel1, categoryLevel2, keySearch, startDate, endDate, language } = params;

      // Setup filter state cho My Topics
      const myTopicsFilterState = {};

      // Handle language filter from URL
      if (language && newState.languages) {
        const languageIds = language.split(',');
        const languageOptions = newState.languages.filter(lang => languageIds.includes(lang.value));
        if (languageOptions.length > 0) {
          myTopicsFilterState.filterLanguageMyTopics = languageOptions;
        }
      } else if (newState.languages && newState.languages.length > 0) {
        // For guide users: default to select both English and Vietnamese
        // For other users: don't set default (empty array)
        if (this.isUserGuide()) {
          myTopicsFilterState.filterLanguageMyTopics = newState.languages;
        }
      }

      // Handle category filters
      if (categoryLevel1) {
        const selectedCategory = categoriesWithChildren.find(cat => cat._id === categoryLevel1);
        if (selectedCategory) {
          myTopicsFilterState.filterCategoryLevel1MyTopics = categoriesLevel1.find(cat => cat.key === categoryLevel1);
          if (selectedCategory.children) {
            const categoriesLevel2 = selectedCategory.children.map(child => ({
              key: child._id,
              value: child._id,
              label: this.getCategoryLabel(child),
            }));
            myTopicsFilterState.categoriesLevel2MyTopics = categoriesLevel2;

            if (categoryLevel2 && categoryLevel2.trim() !== '') {
              const level2Ids = categoryLevel2.split(',');
              myTopicsFilterState.filterCategoryLevel2MyTopics = categoriesLevel2.filter(child => level2Ids.includes(child.key));
            } else {
              // Default: select all level 2
              myTopicsFilterState.filterCategoryLevel2MyTopics = categoriesLevel2;
            }
          }
        }
      }

      if (keySearch) {
        myTopicsFilterState.filterKeySearchMyTopics = keySearch;
      }

      if (startDate || endDate) {
        myTopicsFilterState.filterCreateDateMyTopics = { value: 'other', label: I18n.t('range_calendar'), key: 'other' };
        if (startDate) myTopicsFilterState.startDateMyTopics = moment(Number(startDate));
        if (endDate) myTopicsFilterState.endDateMyTopics = moment(Number(endDate));
      }

      // Build filter params và fetch
      const myTopicsParams = this.buildFilterParamsMyTopics({ ...newState, ...myTopicsFilterState }, 1);
      const myTopics = await getMyTopics(myTopicsParams);

      if (this._isMounted && myTopics.success && myTopics.data && myTopics.data.data) {
        const myTopicsData = myTopics.data.data;
        const listMyTopics = myTopicsData.list || [];
        this.safeSetState({
          exploreSessions,
          listSessions: null, // Set null cho guide user để không hiển thị Popular Topics section
          listMyTopics,
          currentPageMyTopics: myTopicsData.currentPage || 1,
          totalRecordsMyTopics: Number(myTopicsData.total) || 0,
          ...myTopicsFilterState,
        }, () => {
          // Đảm bảo update label sau khi DOM đã render
          this.createTimeout(() => {
            if (this._isMounted && this.state.filterLanguageMyTopics && this.state.filterLanguageMyTopics.length > 0) {
              // Try multiple times to ensure element is rendered
              let attempts = 0;
              const tryUpdateLabel = () => {
                attempts++;
                const element = document.querySelectorAll(`.filterLanguageMyTopics .ant-select-selector`);
                if (element.length > 0) {
                  this.updateFilterLabel('filterLanguageMyTopics', I18n.t('language'));
                } else if (attempts < 10) {
                  setTimeout(tryUpdateLabel, 200);
                }
              };
              tryUpdateLabel();
            }
            if (this._isMounted && this.state.filterCategoryLevel2MyTopics && this.state.filterCategoryLevel2MyTopics.length > 0) {
              this.updateFilterLabel('filterCategoryLevel2MyTopics', I18n.t('session_category_level2'));
            }
          }, 500);
        });
      } else if (this._isMounted) {
        this.safeSetState({ exploreSessions, listSessions: null, listMyTopics: [], ...myTopicsFilterState }, () => {
          // Đảm bảo update label sau khi DOM đã render
          this.createTimeout(() => {
            if (this._isMounted && this.state.filterLanguageMyTopics && this.state.filterLanguageMyTopics.length > 0) {
              // Try multiple times to ensure element is rendered
              let attempts = 0;
              const tryUpdateLabel = () => {
                attempts++;
                const element = document.querySelectorAll(`.filterLanguageMyTopics .ant-select-selector`);
                if (element.length > 0) {
                  this.updateFilterLabel('filterLanguageMyTopics', I18n.t('language'));
                } else if (attempts < 10) {
                  setTimeout(tryUpdateLabel, 200);
                }
              };
              tryUpdateLabel();
            }
            if (this._isMounted && this.state.filterCategoryLevel2MyTopics && this.state.filterCategoryLevel2MyTopics.length > 0) {
              this.updateFilterLabel('filterCategoryLevel2MyTopics', I18n.t('session_category_level2'));
            }
          }, 500);
        });
      }
    }
    this.props.updatePageStatus('loaded');

    this.fetchPendingRatingSession();

    let cred = await Auth.currentUserCredentials();

    if (this._isMounted && (!cred || !cred.authenticated)) {
      this.openMembershipModal();
    }
  }

  fetchPendingRatingSession = async () => {
    const { user } = this.props;
    if (!user) return;
    try {
      const { fetchNeedEvaluateSessions } = this.props;
      const data = await fetchNeedEvaluateSessions();
      if (this._isMounted && data && data.length > 0) {
        this.safeSetState({ pendingRatingSession: data[0] });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    // Detect user type changes and refresh exploreSessions
    const prevUserType = prevProps.user?.type || prevProps.user?.mvpUserType;
    const currentUserType = this.props.user?.type || this.props.user?.mvpUserType;

    if (prevUserType !== currentUserType && this._isMounted) {
      // User type changed, refresh exploreSessions
      const { getMySessions, user } = this.props;

      // Determine if user is Explorer or Guide
      const userType = currentUserType;
      const isExplorer = userType === 'senior' || userType === 'explorer' || userType === 'both';
      const isGuide = userType === 'guide';

      let exploreSessions = [];
      if (user && isExplorer) {
        // Lấy ngôn ngữ hiện tại từ localStorage hoặc I18n
        const currentLanguage = localStorage.getItem('ced:language') || I18n.language || 'vi';

        const mySessions = await getMySessions({
          status: 'is_processing,confirm',
          limit: 10,
          language: currentLanguage
        });

        if (mySessions.success && mySessions.data && mySessions.data.data) {
          const allSessions = mySessions.data.data.list || [];
          const now = Date.now();

          // Filter chỉ lấy upcoming (startTime > now) và ongoing (startTime <= now && endTime >= now)
          // Loại bỏ các session đã kết thúc (endTime < now) hoặc có state = 'is_ended'
          exploreSessions = allSessions.filter(session => {
            if (!session.startTime || !session.endTime) {
              return false;
            }
            const startTime = Number(session.startTime);
            const endTime = Number(session.endTime);

            // Loại bỏ session đã kết thúc (endTime < now)
            if (endTime < now) {
              return false;
            }

            // Loại bỏ session có state = 'is_ended'
            if (session.state === 'is_ended') {
              return false;
            }

            // Loại bỏ session có status = 'reject' hoặc state = 'reject'
            if (session.status === 'reject' || session.state === 'reject') {
              return false;
            }

            // Upcoming: chưa bắt đầu (startTime > now)
            const isUpcoming = startTime > now;
            // Ongoing: đang diễn ra (startTime <= now && endTime >= now)
            const isOngoing = startTime <= now && endTime >= now;
            const shouldShow = isUpcoming || isOngoing;

            return shouldShow;
          });
        }
      } else if (user && isGuide) {
        // For guide user, use fetchMyTopicsForGuide which fetches topics with all filters
        await this.fetchMyTopicsForGuide();
        // Update page status to loaded after fetching topics
        if (this._isMounted) {
          this.props.updatePageStatus('loaded');
        }
        return; // fetchMyTopicsForGuide will update state, so we can return early
      }

      this.safeSetState({ exploreSessions });
    }

    // Refetch categories and update duration options when language changes
    const prevLanguage = prevState.currentI18nLanguage || 'vi';
    const currentLanguage = I18n.language || 'vi';

    if (prevLanguage !== currentLanguage && this._isMounted) {
      // Update current language in state
      this.safeSetState({ currentI18nLanguage: currentLanguage });

      // Update createDate options with new language
      const updatedCreateDate = [
        { value: 'today', label: I18n.t('today') },
        { value: 'yesterday', label: I18n.t('yesterday') },
        { value: 'thisWeek', label: I18n.t('this_week') },
        { value: 'sevenDaysAgo', label: I18n.t('7_days_ago') },
        { value: 'other', label: I18n.t('range_calendar') },
      ];
      this.safeSetState({ createDate: updatedCreateDate });

      // Update selected createDate label if exists
      if (this.state.filterCreateDate) {
        const updatedCreateDateOption = updatedCreateDate.find(opt => opt.value === this.state.filterCreateDate.value);
        if (updatedCreateDateOption) {
          this.safeSetState({ filterCreateDate: updatedCreateDateOption });
        }
      }

      // Update language options with new language
      if (this.props.listLanguage && this.props.listLanguage.length > 0) {
        const languages = this.props.listLanguage.map(item => {
          let label = item.label;
          // If current website language is Vietnamese, show Vietnamese labels
          if (currentLanguage === 'vi') {
            label = item.value === 'vi' ? 'Tiếng Việt' : 'Tiếng Anh';
          } else {
            // If current website language is English, show English labels
            label = item.value === 'en' ? 'English' : 'Vietnamese';
          }
          return {
            key: item.value,
            value: item.value,
            label: label,
          };
        });
        this.safeSetState({ languages: languages });

        // Update selected language labels if exists
        if (this.state.filterLanguage && this.state.filterLanguage.length > 0) {
          const updatedFilterLanguage = this.state.filterLanguage.map(selected => {
            const updated = languages.find(lang => lang.key === selected.key);
            return updated || selected;
          }).filter(Boolean);
          this.safeSetState({ filterLanguage: updatedFilterLanguage });
        }
      }

      // Update duration options with new language
      if (this.state.durations && this.state.durations.length > 0) {
        const updatedDurations = this.state.durations.map(item => ({
          ...item,
          label: `${item.value} ${I18n.t('minutes')}`,
        }));
        this.safeSetState({ durations: updatedDurations });

        // Update selected duration label if exists
        if (this.state.filterDuration) {
          const updatedDuration = updatedDurations.find(d => d.key === this.state.filterDuration.key);
          if (updatedDuration) {
            this.safeSetState({ filterDuration: updatedDuration });
          }
        }
      }

      // Update filter labels when language changes
      // Use createTimeout with cleanup tracking
      this.createTimeout(() => {
        if (!this._isMounted) return;

        // Update Topic Creation Time filter label
        this.createTimeout(() => {
          if (!this._isMounted) return;

          if (this.state.filterCreateDate) {
            this.updateFilterLabelForPopularTopicsDate();
          } else {
            // Update placeholder even when no selection
            let element = document.querySelectorAll(`.createDatePopularTopics .ant-select-selector`);
            if (element.length > 0 && element[0]) {
              let placeholder = element[0].querySelector('.ant-select-selection-placeholder');
              if (placeholder) {
                placeholder.textContent = I18n.t('topic_creation_time');
              }
            }
          }
          // Update Language filter label
          const languageLabel = I18n.t('language');
          if (this.state.filterLanguage && this.state.filterLanguage.length > 0) {
            this.createTimeout(() => {
              if (this._isMounted) {
                this.updateFilterLabel('filterLanguage', languageLabel);
              }
            }, 100);
          } else {
            // Update placeholder even when no selection
            let element = document.querySelectorAll(`.filterLanguage .ant-select-selector`);
            if (element.length > 0 && element[0]) {
              let placeholder = element[0].querySelector('.ant-select-selection-placeholder');
              if (placeholder) {
                placeholder.textContent = languageLabel;
              }
            }
          }
        }, 50);
      }, 100);

      // Fetch categories again with new language
      const { getCategorySessions } = this.props;
      try {
        const categories = await getCategorySessions();
        // Check if component is still mounted before updating state
        if (!this._isMounted) return;
        if (categories) {
          const categoriesLevel1 = categories?.map(item => ({
            key: item._id,
            value: item._id,
            label: this.getCategoryLabel(item),
          })) || [];

          // Update categories in state
          this.safeSetState({
            categoriesLevel1,
            categoriesWithChildren: categories || []
          });

          // If there's a selected category, update its label
          if (this._isMounted && this.state.filterCategoryLevel1) {
            const updatedCategory = categoriesLevel1.find(cat => cat.key === this.state.filterCategoryLevel1.key);
            if (updatedCategory) {
              this.safeSetState({ filterCategoryLevel1: updatedCategory });
            }
          }

          // Update category level 2 if exists
          if (this._isMounted && this.state.filterCategoryLevel1 && this.state.categoriesLevel2) {
            const selectedCategory = categories.find(cat => cat._id === this.state.filterCategoryLevel1.value);
            if (selectedCategory && selectedCategory.children) {
              const categoriesLevel2 = selectedCategory.children.map(child => ({
                key: child._id,
                value: child._id,
                label: this.getCategoryLabel(child),
              }));
              this.safeSetState({ categoriesLevel2 });

              // Update selected level 2 categories
              if (this.state.filterCategoryLevel2 && this.state.filterCategoryLevel2.length > 0) {
                const updatedLevel2 = this.state.filterCategoryLevel2.map(selected => {
                  const updated = categoriesLevel2.find(cat => cat.key === selected.key);
                  return updated || selected;
                }).filter(Boolean);
                this.safeSetState({ filterCategoryLevel2: updatedLevel2 });
              }
            }
          }
        }
      } catch (error) {
        // Error refetching categories - silently fail
      }
    }

    // Check if I18n.language has changed (website language changed)
    const currentI18nLanguage = I18n.language || 'vi';
    const prevI18nLanguage = prevState.currentI18nLanguage || 'vi';
    const i18nLanguageChanged = currentI18nLanguage !== prevI18nLanguage;

    // Helper function to map language labels according to current website language
    const mapLanguageLabels = (listLanguage) => {
      if (!listLanguage || !listLanguage.length) return [];
      const currentLanguage = I18n.language || 'vi';
      return listLanguage.map(item => {
        let label = item.label;
        // If current website language is Vietnamese, show Vietnamese labels
        if (currentLanguage === 'vi') {
          label = item.value === 'vi' ? 'Tiếng Việt' : 'Tiếng Anh';
        } else {
          // If current website language is English, show English labels
          label = item.value === 'en' ? 'English' : 'Vietnamese';
        }
        return {
          key: item.value,
          value: item.value,
          label: label,
        };
      });
    };

    // Re-map language labels if listLanguage changed OR I18n.language changed
    if (this.props.listLanguage !== prevProps.listLanguage || i18nLanguageChanged) {
      const searchParams = new URLSearchParams(this.props.location.search);
      const language = searchParams.get('language');

      // Map language labels according to current website language
      const languages = mapLanguageLabels(this.props.listLanguage);
      this.safeSetState({
        languages: languages,
        currentI18nLanguage: currentI18nLanguage
      });

      if (this._isMounted) {
        // For guide users, use filterLanguageMyTopics; for others, use filterLanguage
        const selectName = this.isUserGuide() ? 'filterLanguageMyTopics' : 'filterLanguage';

        if (language) {
          const languageIds = language.split(',');
          const data = languages.filter(obj => languageIds.includes(obj.key));
          if (data.length > 0) {
            this.handleSelectMulti(data, selectName, I18n.t('language'));
          }
        } else if (this.isUserGuide() && languages.length > 0) {
          // Default: select both languages for guide users
          this.handleSelectMulti(languages, 'filterLanguageMyTopics', I18n.t('language'));
        } else if (languages.length > 0 && !this.isUserGuide()) {
          // For non-guide users, set filterLanguage
          this.handleSelectMulti(languages, 'filterLanguage', I18n.t('language'));
        }
      }

      // If I18n.language changed, update the labels of already-selected languages
      if (i18nLanguageChanged && this._isMounted) {
        // Update filterLanguage for non-guide users (Popular Topics)
        if (!this.isUserGuide() && this.state.filterLanguage && this.state.filterLanguage.length > 0) {
          const updatedFilterLanguage = this.state.filterLanguage.map(selectedLang => {
            const updatedLang = languages.find(l => l.value === selectedLang.value || l.key === selectedLang.value);
            return updatedLang || selectedLang;
          });
          this.safeSetState({ filterLanguage: updatedFilterLanguage });
        }

        // Update filterLanguageMyTopics for guide users (My Topics)
        if (this.isUserGuide() && this.state.filterLanguageMyTopics && this.state.filterLanguageMyTopics.length > 0) {
          const updatedFilterLanguageMyTopics = this.state.filterLanguageMyTopics.map(selectedLang => {
            const updatedLang = languages.find(l => l.value === selectedLang.value || l.key === selectedLang.value);
            return updatedLang || selectedLang;
          });
          this.safeSetState({ filterLanguageMyTopics: updatedFilterLanguageMyTopics });
        }
      }

      // Đảm bảo update label sau khi DOM đã render
      this.createTimeout(() => {
        // Update label for non-guide users
        if (this._isMounted && !this.isUserGuide() && this.state.filterLanguage && this.state.filterLanguage.length > 0) {
          this.createTimeout(() => {
            if (this._isMounted) {
              this.updateFilterLabel('filterLanguage', I18n.t('language'));
            }
          }, 100);
        }
        // Update label for guide users (My Topics)
        if (this._isMounted && this.isUserGuide() && this.state.filterLanguageMyTopics && this.state.filterLanguageMyTopics.length > 0) {
          this.createTimeout(() => {
            if (this._isMounted) {
              // Try multiple times to ensure element is rendered
              let attempts = 0;
              const tryUpdateLabel = () => {
                attempts++;
                const element = document.querySelectorAll(`.filterLanguageMyTopics .ant-select-selector`);
                if (element.length > 0) {
                  this.updateFilterLabel('filterLanguageMyTopics', I18n.t('language'));
                } else if (attempts < 10) {
                  setTimeout(tryUpdateLabel, 200);
                }
              };
              tryUpdateLabel();
            }
          }, 500);
        }
      }, 100);
    }

    const { filterCategories, filterEvaluating, filterKeySearch, filterCreateDate, filterRole, filterLanguage, filterCategoryLevel1, filterCategoryLevel2, filterDuration } = this.state;

    const currentFilters = {
      filterCategories,
      filterEvaluating,
      filterKeySearch,
      filterCreateDate,
      filterRole,
      filterLanguage,
      filterCategoryLevel1,
      filterCategoryLevel2,
      filterDuration
    };
    const prevFilters = {
      filterCategories: prevState.filterCategories,
      filterEvaluating: prevState.filterEvaluating,
      filterKeySearch: prevState.filterKeySearch,
      filterCreateDate: prevState.filterCreateDate,
      filterRole: prevState.filterRole,
      filterLanguage: prevState.filterLanguage,
      filterCategoryLevel1: prevState.filterCategoryLevel1,
      filterCategoryLevel2: prevState.filterCategoryLevel2,
      filterDuration: prevState.filterDuration,
    };
    const handleToOther = prevState.filterCreateDate !== filterCreateDate && this.isOther()
    if (handleToOther) {
      return
    }
    if (!_.isEqual(currentFilters, prevFilters)) {
      await this.handleChangeDebounced();
    }
  }


  // Dummies
  mapUrlToFilter = () => { };
  isOther = () => { };
  isOtherMyTopics = () => { };
  getCategoryLabel = () => { };
  updateFilterLabelForPopularTopicsDate = () => { };
  handleDropdownVisibleChange = () => { };
  handleDropdownVisibleChangeMyTopics = () => { };
  handleSelectCategoryLevel1 = () => { };
  renderSelect = () => { };
  renderSelectMulti = () => { };
  renderSelectDate = () => { };
  renderSelectDateForPopularTopics = () => { };
  renderSelectDateMyTopics = () => { };
  changeStandardTextColor = () => { };
  changeRevertTextColor = () => { };
  checkStatusVerified = () => { };
  checkUserStatusVerify = () => { };
  getWarningTitle = () => { };
  getWarningContent = () => { };
  getVerifyButtonLabel = () => { };
  getVerifyIcon = () => { };
  getAlertBackgroundColor = () => { };
  isUserGuide = () => { return true; };

  render() {
    const { totalRecords, pageLimit, listSessions, exploreSessions } = this.state;
    const warningTitle = this.getWarningTitle();
    const warningContent = this.getWarningContent();
    const verifyButtonLabel = this.getVerifyButtonLabel();
    const verifyIcon = this.getVerifyIcon();
    const alertBackgroundColor = this.getAlertBackgroundColor();
    const kambria = 'https://kambria.io/docs/ced/overview-of-ced/'

    return (
      <div id="site_wrapper">
        <div className="site-upper" style={this.style}>
          {this.props.header}
          <PageHero headline="CED" description={I18n.t('tecd_slogan')} />
        </div>
        <main className="main">
          <div className="container">
            {warningTitle && (
              <div className="" style={{
                padding: '10px',
                marginTop: '10px',
                backgroundColor: alertBackgroundColor,
                border: '1px solid #ffeaa7',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '15px',
                marginBottom: '0px !important'
              }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  marginTop: '2px'
                }}>
                  <img
                    src={verifyIcon}
                    alt="Warning"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '400', color: '#111827', marginBottom: '8px', fontSize: '16px' }}>
                    {warningTitle}
                  </div>
                  <div style={{ color: '#6B7280', marginBottom: '8px', fontSize: '14px', lineHeight: '1.4' }}>
                    {warningContent}
                  </div>
                  <div
                    style={{ color: '#111827', textDecoration: 'underline', cursor: 'pointer', fontSize: '14px' }}
                    onClick={this.openVerifyModal}
                  >
                    {verifyButtonLabel}
                  </div>
                </div>
              </div>
            )}
            <div style={{ paddingTop: '44px' }}>
              <div className="iframe-container">
                <iframe
                  src={kambria}
                  name="myiFrame"
                  id="myIframe"
                  scrolling="yes"
                  marginHeight="0px"
                  marginWidth="0px"
                  allowFullScreen
                  style={{ border: 'none', width: '100%', height: '686px' }}
                />
              </div>
            </div>
            <PageLoader loading={!this.isUserGuide() ? !listSessions : !this.state.listMyTopics} />
            {this.state.pendingRatingSession && (
              <RatingFloatNotification
                session={this.state.pendingRatingSession}
                onDismiss={() => this.safeSetState({ pendingRatingSession: null })}
              />
            )}
            {/* Show "Your Session" section for explorer users when they have explore sessions */}
            {!this.isUserGuide() && exploreSessions && exploreSessions.length > 0 && (
              <Section title={I18n.t('your_session')} url="/" className="card-section">
                <div className="row">
                  {exploreSessions.map((item, index) => {
                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <CardMvpSession key={index} data={item} status={item.status} url={config.sites.bounty} user={this.props.user} linkToSessionDetail />
                      </div>
                    );
                  })}
                </div>
                <div style={{ textAlign: 'right', marginTop: '16px' }}>
                  <Link to={`/my-session?status=is_processing,upcoming`}>
                    {I18n.t('view_all_my_sessions')} ({exploreSessions.length})
                  </Link>
                </div>
              </Section>
            )}
            {/* Show "My topic" section for guide users, even when empty */}
            {this.isUserGuide() && (
              <Section title={I18n.t('my_topic')} url="/" className="card-section">
                <div className="mtp-filter-zone">
                  <div className="search">
                    <FontAwesomeIcon className="cursor-pointer" icon={faSearch}
                      style={{ fontSize: '18px', color: '#9CA3AF' }} />
                    <input value={this.state.filterKeySearchMyTopics || ''} onChange={this.handleSearchChangeMyTopics}
                      placeholder={I18n.t('my_dashboard_topic_search_hint_text')} />
                  </div>
                  <div className="select">
                    {this.renderSelect({
                      label: I18n.t('session_category_label_required'),
                      select: 'filterCategoryLevel1MyTopics',
                      options: this.state.categoriesLevel1,
                      onChange: (value) => this.handleSelectCategoryLevel1MyTopics(value, 'filterCategoryLevel1MyTopics', I18n.t('session_category_label_required')),
                      onFilter: this.handleFilterMyTopics,
                    })}
                    {this.state.filterCategoryLevel1MyTopics && this.state.categoriesLevel2MyTopics && this.state.categoriesLevel2MyTopics.length > 0 && this.renderSelectMulti({
                      label: I18n.t('session_category_level2') || 'Sub Category',
                      select: 'filterCategoryLevel2MyTopics',
                      options: this.state.categoriesLevel2MyTopics,
                      onFilter: this.handleFilterMyTopics,
                    })}
                    {this.renderSelectDateMyTopics(this.state.createDate)}
                    {/* {this.renderSelect({
                      label: I18n.t('rating'),
                      select: 'filterRatingMyTopics',
                      options: this.state.ratingOptionsMyTopics,
                      onChange: (value) => this.handleSelectRatingMyTopics(value, 'filterRatingMyTopics', I18n.t('rating')),
                      onFilter: this.handleFilterMyTopics,
                    })} */}
                    {this.state.languages && this.state.languages.length > 0 && this.renderSelectMulti({
                      label: I18n.t('language'),
                      select: 'filterLanguageMyTopics',
                      options: this.state.languages,
                      onFilter: this.handleFilterMyTopics,
                    })}
                  </div>
                </div>
                {this.state.listMyTopics && this.state.listMyTopics.length > 0 ? (
                  <>
                    <div className="row">
                      {this.state.listMyTopics.map((item, index) => {
                        return (
                          <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <CardMvpSession key={index} data={item} status={item.status} url={config.sites.bounty} user={this.props.user} />
                          </div>
                        );
                      })}
                    </div>

                    {this.state.totalRecordsMyTopics > 0 && (
                      <Pagination
                        totalRecords={this.state.totalRecordsMyTopics}
                        pageLimit={this.state.pageLimitMyTopics}
                        pageNeighbours={1}
                        onPageChanged={this.onPageChangedMyTopics}
                      />
                    )}
                  </>
                ) : (
                  <div className="text-center py-5">
                    <p style={{ color: '#9CA3AF', fontSize: '16px' }}>
                      {I18n.t('my_topic_empty_text') || 'Không có bản ghi nào'}
                    </p>
                  </div>
                )}
              </Section>
            )}

            {listSessions !== null && !this.isUserGuide() && (
              <Section title={I18n.t('popular_topics')} url="/" className="card-section">
                <div className="mtp-filter-zone">
                  <div className="select">
                    {this.props.user && this.props.user.type === 'seniorBuddy' && (this.renderSelect({
                      label: I18n.t('dashboard_filter_provider'),
                      select: 'filterRole',
                      options: this.state.roles,
                    }))}
                    {this.renderSelect({
                      label: I18n.t('session_category_label_required'),
                      select: 'filterCategoryLevel1',
                      options: this.state.categoriesLevel1,
                      onChange: (value) => this.handleSelectCategoryLevel1(value, 'filterCategoryLevel1', I18n.t('session_category_label_required')),
                    })}
                    {this.state.filterCategoryLevel1 && this.state.categoriesLevel2 && this.state.categoriesLevel2.length > 0 && this.renderSelectMulti({
                      label: I18n.t('session_category_level2') || 'Sub Category',
                      select: 'filterCategoryLevel2',
                      options: this.state.categoriesLevel2,
                    })}
                    {this.renderSelectDateForPopularTopics(this.state.createDate)}
                    {this.state.languages && this.state.languages.length > 0 && this.renderSelectMulti({
                      label: I18n.t('language'),
                      select: 'filterLanguage',
                      options: this.state.languages,
                    })}
                    {this.state.durations && this.state.durations.length > 0 && this.renderSelect({
                      label: I18n.t('duration_of_each_session'),
                      select: 'filterDuration',
                      options: this.state.durations,
                    })}
                  </div>
                </div>
                {listSessions.length > 0 ? (
                  <>
                    <div className="row">
                      {listSessions.map((item, index) => {
                        return (
                          <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <CardMvpSession key={index} data={item} status={item.status} url={config.sites.bounty} />
                          </div>
                        );
                      })}
                    </div>

                    {totalRecords > 0 && (
                      <Pagination
                        totalRecords={totalRecords}
                        pageLimit={pageLimit}
                        pageNeighbours={1}
                        onPageChanged={this.onPageChanged}
                      />
                    )}
                  </>
                ) : (
                  <div className="text-center py-5">
                    <p style={{ color: '#9CA3AF', fontSize: '16px' }}>
                      {I18n.t('my_topic_empty_text')}
                    </p>
                  </div>
                )}
              </Section>
            )}
          </div>
        </main>
        {this.props.footer}

        <ModalPopup
          size="sm"
          show={this.state.showVerifyModal}
          onHide={this.closeVerifyModal}
          id="remove-session-modal"
          style={{ opacity: 1 }}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <ModalPopup.Header>
            <a
              type="button"
              className="close-button-forget"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.closeVerifyModal}
            >
              x
            </a>
          </ModalPopup.Header>
          <ModalPopup.Body>
            {/* QR Code */}
            <div style={{ marginBottom: '20px' }}>
              <div style={{
                width: '200px',
                height: '200px',
                backgroundColor: 'white',
                margin: '0 auto',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px'
              }}>
                <img
                  src={qrVerify}
                  alt="QR Code"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                  }}
                />
              </div>
            </div>

            {/* Title */}
            <h3 style={{
              color: 'white',
              marginBottom: '15px',
              fontSize: '20px',
              fontWeight: '600'
            }}>
              {I18n.t('become_verified_partner')}
            </h3>

            {/* Description */}
            <p style={{
              color: '#D1D5DB',
              marginBottom: '25px',
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              {I18n.t('verify_modal_description')}
            </p>
          </ModalPopup.Body>
        </ModalPopup>

        {/* Verify Identity Modal */}
      </div>
    );
  }


  mapUrlToFilter = () => {
    const searchParams = new URLSearchParams(this.props.location?.search || '');
    const categoryId = searchParams.get('categoryId');
    const categoryLevel1 = searchParams.get('categoryLevel1');
    const categoryLevel2 = searchParams.get('categoryLevel2');
    const evaluating = searchParams.get('evaluating');
    const keySearch = searchParams.get('keySearch');
    const startDate = searchParams.get('startDate');
    const endDate = searchParams.get('endDate');
    const role = searchParams.get('role');
    const language = searchParams.get('language');
    // Không đọc page từ URL query string - sử dụng giá trị mặc định
    return { categoryId, categoryLevel1, categoryLevel2, evaluating, keySearch, startDate, endDate, role, language }
  }

  mapFilterToUrl = (params) => {
    const searchParams = new URLSearchParams();
    // Loại bỏ page và limit khỏi URL query string
    const excludeKeys = ['page', 'limit'];
    Object.keys(params).forEach(key => {
      if (!excludeKeys.includes(key) && params[key]) {
        searchParams.set(key, params[key]);
      } else {
        searchParams.delete(key);
      }
    })
    if (this.props.history?.push) {
      this.props.history.push({ search: searchParams.toString() });
    }
  }

  buildFilterParams = (state = this.state, currentPage = null) => {
    const { filterEvaluating, filterCategories, filterKeySearch, filterCreateDate, filterRole, filterLanguage, filterCategoryLevel1, filterCategoryLevel2, filterDuration, pageLimit } = state || this.state;

    // Map categoryLevel1/categoryLevel2 to categoryId for API
    let categoryId = null;
    if (filterCategoryLevel1) {
      const selectedCategory = (state || this.state).categoriesWithChildren?.find(cat => cat._id === filterCategoryLevel1.value);
      if (selectedCategory) {
        if (filterCategoryLevel2 && filterCategoryLevel2.length > 0) {
          // Use level 2 categories
          categoryId = filterCategoryLevel2.map(c => c.value).join(',');
        } else if (selectedCategory.children) {
          // Use all level 2 categories
          categoryId = selectedCategory.children.map(c => c._id).join(',');
        } else {
          // No children, use level 1
          categoryId = filterCategoryLevel1.value;
        }
      }
    } else if (filterCategories && filterCategories.length) {
      categoryId = filterCategories.map(c => c.value).join(',');
    }

    const role = filterRole?.value || null;
    let language = null;
    if (filterLanguage && filterLanguage.length) {
      const allLanguagesSelected = (state || this.state).languages.length > 0 &&
        filterLanguage.length === (state || this.state).languages.length &&
        filterLanguage.every(fl => (state || this.state).languages.some(l => l.key === fl.key));

      if (!allLanguagesSelected) {
        language = filterLanguage.map(l => l.value).join(',');
      }
    }

    let evaluating = null;
    if (filterEvaluating && filterEvaluating.length) {
      evaluating = filterEvaluating.map(c => c.value).join(',');
    }

    const keySearch = filterKeySearch;
    let startDate, endDate;
    if (filterCreateDate && filterCreateDate.value) {
      const filterDate = this.getStartEndDate(filterCreateDate.value);
      startDate = filterDate.startDate;
      endDate = filterDate.endDate;
    }

    const params = {};
    if (categoryId) params.categoryId = categoryId;
    if (evaluating) params.evaluating = evaluating;
    if (keySearch) params.keySearch = keySearch;
    if (startDate) {
      // Format date theo local timezone (giống với server)
      // startDate là timestamp, convert về moment và format
      params.startDate = moment(startDate).format('DD-MM-YYYY');
    }
    if (endDate) {
      // Format date theo local timezone (giống với server)
      // endDate là timestamp, convert về moment và format
      params.endDate = moment(endDate).format('DD-MM-YYYY');
    }
    if (role) params.role = role;
    if (language) params.language = language;
    if (filterDuration) params.duration = filterDuration.value;
    // Sử dụng giá trị mặc định: page = 1, limit = 12 nếu không có query string
    params.page = currentPage !== null && currentPage !== undefined ? currentPage : 1;
    params.limit = pageLimit || 12;

    return params;
  }

  getStartEndDate = (date) => {
    if (!date) {
      return { startDate: null, endDate: null };
    }
    let startDate, endDate;
    switch (date) {
      case 'today':
        startDate = moment().startOf('day');
        endDate = moment().endOf('day');
        break;
      case 'yesterday':
        startDate = moment().subtract(1, 'days').startOf('day');
        endDate = moment().subtract(1, 'days').endOf('day');
        break;
      case 'thisWeek':
        startDate = moment().startOf('week').startOf('day');
        endDate = moment().endOf('week').endOf('day');
        break;
      case 'sevenDaysAgo':
        startDate = moment().subtract(7, 'days').startOf('day');
        endDate = moment().endOf('day');
        break;
      default:
        if (this.state.startDate) {
          startDate = moment(this.state.startDate).startOf('day');
        }
        if (this.state.endDate) {
          endDate = moment(this.state.endDate).endOf('day');
        }
        break;
    }
    return {
      startDate: startDate?.valueOf() || null,
      endDate: endDate?.valueOf() || null
    };
  }

  onPageChanged = async ({ currentPage }) => {
    // Don't call getSessions for guide users - they should use getMySessions
    if (this.isUserGuide()) {
      return;
    }

    this.setState({ currentPage });
    const { getSessions } = this.props;

    const params = this.buildFilterParams(this.state, currentPage);
    // Không cập nhật URL với page và limit - chỉ cập nhật các filter khác
    this.mapFilterToUrl(params);

    const sessions = await getSessions(params);

    if (this._isMounted && sessions.success) {
      const data = sessions.data.data;
      const listSessions = data.list || [];
      this.safeSetState({
        listSessions,
        currentPage: data.currentPage || currentPage,
        totalRecords: Number(data.total) || 0,
      });
    }
  };

  buildFilterParamsMyTopics = (state = this.state, currentPage = null) => {
    // const { filterEvaluating, filterRatingMyTopics, filterKeySearchMyTopics, filterCreateDateMyTopics, filterLanguageMyTopics, filterCategoryLevel1MyTopics, filterCategoryLevel2MyTopics, pageLimitMyTopics, categoriesWithChildren } = state || this.state;
    const { filterEvaluating, filterKeySearchMyTopics, filterCreateDateMyTopics, filterLanguageMyTopics, filterCategoryLevel1MyTopics, filterCategoryLevel2MyTopics, pageLimitMyTopics, categoriesWithChildren } = state || this.state;

    // Map categoryLevel1/categoryLevel2 to categoryId for API
    let categoryId = null;
    let categoryLevel1 = null;
    let categoryLevel2 = null;

    if (filterCategoryLevel1MyTopics) {
      categoryLevel1 = filterCategoryLevel1MyTopics.value;
      const selectedCategory = (state || this.state).categoriesWithChildren?.find(cat => cat._id === filterCategoryLevel1MyTopics.value);
      if (selectedCategory) {
        if (filterCategoryLevel2MyTopics && filterCategoryLevel2MyTopics.length > 0) {
          // Use level 2 categories
          categoryLevel2 = filterCategoryLevel2MyTopics.map(c => c.value).join(',');
          categoryId = categoryLevel2;
        } else if (selectedCategory.children) {
          // Use all level 2 categories
          categoryId = selectedCategory.children.map(c => c._id).join(',');
        } else {
          // No children, use level 1
          categoryId = filterCategoryLevel1MyTopics.value;
        }
      }
    }

    let language = null;
    if (filterLanguageMyTopics && filterLanguageMyTopics.length) {
      const allLanguagesSelected = (state || this.state).languages.length > 0 &&
        filterLanguageMyTopics.length === (state || this.state).languages.length &&
        filterLanguageMyTopics.every(fl => (state || this.state).languages.some(l => l.key === fl.key));

      if (!allLanguagesSelected) {
        language = filterLanguageMyTopics.map(l => l.value).join(',');
      }
    }

    const keySearch = filterKeySearchMyTopics;
    let startDate, endDate;
    if (filterCreateDateMyTopics && filterCreateDateMyTopics.value) {
      const filterDate = this.getStartEndDateMyTopics(filterCreateDateMyTopics.value);
      startDate = filterDate.startDate;
      endDate = filterDate.endDate;
    }

    const evaluating = null; //filterRatingMyTopics?.value || null;

    const params = {};
    if (categoryLevel1) params.categoryLevel1 = categoryLevel1;
    if (categoryLevel2) params.categoryLevel2 = categoryLevel2;
    if (categoryId && !categoryLevel1) params.categoryId = categoryId; // Fallback nếu không có categoryLevel1
    if (keySearch) params.keySearch = keySearch;
    if (startDate) {
      params.startDate = startDate.toString();
    }
    if (endDate) {
      params.endDate = endDate.toString();
    }
    if (evaluating) params.evaluating = evaluating;
    if (language) params.language = language;
    // Sử dụng giá trị mặc định: page = 1, limit = 12 nếu không có query string
    params.page = currentPage !== null && currentPage !== undefined ? currentPage : 1;
    params.limit = pageLimitMyTopics || 12;

    return params;
  };

  buildFilterParamsMySessions = (state = this.state, currentPage = null) => {
    const stateToUse = state || this.state;
    const {
      // filterRatingMySessions,
      filterKeySearchMySessions,
      filterCreateDateMySessions,
      filterLanguageMySessions,
      filterCategoryLevel1MySessions,
      filterCategoryLevel2MySessions,
      pageLimitMySessions,
      sharingTopicsCategories
    } = stateToUse;

    // Map categoryLevel1/categoryLevel2 to categoryId for API
    let categoryId = null;
    let categoryLevel1 = null;
    let categoryLevel2 = null;

    if (filterCategoryLevel1MySessions) {
      categoryLevel1 = filterCategoryLevel1MySessions.value;
      const selectedCategory = sharingTopicsCategories?.find(cat => {
        const catId = cat._id?.toString() || cat._id;
        const valueId = filterCategoryLevel1MySessions.value?.toString() || filterCategoryLevel1MySessions.value;
        return catId === valueId;
      });
      if (selectedCategory) {
        if (filterCategoryLevel2MySessions && filterCategoryLevel2MySessions.length > 0) {
          // Use level 2 categories
          categoryLevel2 = filterCategoryLevel2MySessions.map(c => c.value).join(',');
          categoryId = categoryLevel2;
        } else if (selectedCategory.children) {
          // Use all level 2 categories
          categoryId = selectedCategory.children.map(c => c._id).join(',');
        } else {
          // No children, use level 1
          categoryId = filterCategoryLevel1MySessions.value;
        }
      }
    }

    let language = null;
    if (filterLanguageMySessions && filterLanguageMySessions.length) {
      const allLanguagesSelected = (state || this.state).languages.length > 0 &&
        filterLanguageMySessions.length === (state || this.state).languages.length &&
        filterLanguageMySessions.every(fl => (state || this.state).languages.some(l => l.key === fl.key));

      if (!allLanguagesSelected) {
        language = filterLanguageMySessions.map(l => l.value).join(',');
      }
    }

    const keySearch = filterKeySearchMySessions;
    let startDate, endDate;
    if (filterCreateDateMySessions && filterCreateDateMySessions.value) {
      const filterDate = this.getStartEndDateMySessions(filterCreateDateMySessions.value);
      startDate = filterDate.startDate;
      endDate = filterDate.endDate;
    }
  }

  getStartEndDateMyTopics = (date) => {
    if (!date) {
      return { startDate: null, endDate: null };
    }
    let startDate, endDate;
    switch (date) {
      case 'today':
        startDate = moment().startOf('day');
        endDate = moment().endOf('day');
        break;
      case 'yesterday':
        startDate = moment().subtract(1, 'days').startOf('day');
        endDate = moment().subtract(1, 'days').endOf('day');
        break;
      case 'thisWeek':
        startDate = moment().startOf('week').startOf('day');
        endDate = moment().endOf('week').endOf('day');
        break;
      case 'sevenDaysAgo':
        startDate = moment().subtract(7, 'days').startOf('day');
        endDate = moment().endOf('day');
        break;
      default:
        if (this.state.startDateMyTopics) {
          startDate = moment(this.state.startDateMyTopics).startOf('day');
        }
        if (this.state.endDateMyTopics) {
          endDate = moment(this.state.endDateMyTopics).endOf('day');
        }
        break;
    }
    return {
      startDate: startDate?.valueOf() || null,
      endDate: endDate?.valueOf() || null
    };
  };

  fetchMyTopicsForGuide = async () => {
    if (!this._isMounted) return;

    const { getMyTopics, user } = this.props;
    const userType = user?.type || user?.mvpUserType;
    const isGuide = userType === 'guide';

    if (!user || !isGuide) {
      return;
    }

    // Build params with all filters
    const params = this.buildFilterParamsMyTopics(this.state, 1);

    const myTopics = await getMyTopics(params);

    if (this._isMounted) {
      let listMyTopics = [];

      if (myTopics.success && myTopics.data && myTopics.data.data) {
        listMyTopics = myTopics.data.data.list || [];
        const myTopicsData = myTopics.data.data;

        this.safeSetState({
          listMyTopics,
          currentPageMyTopics: myTopicsData.currentPage || 1,
          totalRecordsMyTopics: Number(myTopicsData.total) || 0,
        });
      } else {
        // Always set listMyTopics (even if empty) to show empty state
        this.safeSetState({
          listMyTopics: [],
          currentPageMyTopics: 1,
          totalRecordsMyTopics: 0,
        });
      }
    }
  };



  handleSearchChangeMyTopics = async (e) => {
    const value = e.target.value.trim();
    this.setState({ filterKeySearchMyTopics: value }, () => {
      this.handleChangeDebouncedMyTopics();
    });
  };

  handleSelectCategoryLevel1MyTopics = (value, select, label) => {
    if (!value) {
      this.safeSetState({
        filterCategoryLevel1MyTopics: null,
        filterCategoryLevel2MyTopics: [],
        categoriesLevel2MyTopics: [],
      }, () => {
        if (this._isMounted) {
          this.handleClearSelect(null, select);
        }
      });
      return;
    }

    const selectedCategory = this.state.categoriesWithChildren.find(cat => cat._id === value.value);

    if (selectedCategory && selectedCategory.children) {
      const allLevel2 = selectedCategory.children.map(child => ({
        key: child._id,
        value: child._id,
        label: this.getCategoryLabel(child),
      }));

      this.safeSetState({
        [select]: value,
        filterCategoryLevel2MyTopics: allLevel2,
        categoriesLevel2MyTopics: allLevel2
      }, () => {
        if (!this._isMounted) return;
        this.updateFilterLabel(select, label);
        if (allLevel2.length > 0) {
          this.createTimeout(() => {
            if (this._isMounted) {
              this.updateFilterLabel('filterCategoryLevel2MyTopics', I18n.t('session_category_level2') || 'Sub Category');
            }
          }, 100);
        }
      });
    } else {
      this.safeSetState({
        [select]: value,
        filterCategoryLevel2MyTopics: [],
        categoriesLevel2MyTopics: []
      }, () => {
        if (!this._isMounted) return;
        this.updateFilterLabel(select, label);
      });
    }
  };

  handleFilterMyTopics = async (event) => {
    if (event) {
      event.target.blur();
    }

    // Reset về page 1 khi filter thay đổi
    const params = this.buildFilterParamsMyTopics(this.state, 1);
    // Không cập nhật URL với page và limit - chỉ cập nhật các filter khác
    this.mapFilterToUrl(params);

    const { getMyTopics } = this.props;
    const myTopics = await getMyTopics(params);
    if (this._isMounted && myTopics.success && myTopics.data && myTopics.data.data) {
      const myTopicsData = myTopics.data.data;
      const listMyTopics = myTopicsData.list || [];
      this.safeSetState({
        listMyTopics,
        currentPageMyTopics: myTopicsData.currentPage || 1,
        totalRecordsMyTopics: Number(myTopicsData.total) || 0,
      });
    }
  };

  handleChangeDebouncedMyTopics = debounce(() => this.handleFilterMyTopics(null), 500);

  onPageChangedMyTopics = async ({ currentPage }) => {
    this.setState({ currentPageMyTopics: currentPage });
    const { getMyTopics } = this.props;

    const params = this.buildFilterParamsMyTopics(this.state, currentPage);
    // Không cập nhật URL với page và limit - chỉ cập nhật các filter khác
    this.mapFilterToUrl(params);

    const myTopics = await getMyTopics(params);

    if (this._isMounted && myTopics.success && myTopics.data && myTopics.data.data) {
      const myTopicsData = myTopics.data.data;
      const listMyTopics = myTopicsData.list || [];
      this.safeSetState({
        listMyTopics,
        currentPageMyTopics: myTopicsData.currentPage || currentPage,
        totalRecordsMyTopics: Number(myTopicsData.total) || 0,
      });
    }
  };

  // My Sessions handlers for guide
  handleSelectRatingMyTopics = (value, select, label) => {
    if (!value) {
      this.handleClearSelect(null, select);
      return;
    }
    this.safeSetState({ [select]: value }, () => {
      if (!this._isMounted) {
        return;
      }
      const selectedItems = this.state[select];
      let title = label;
      let element = document.querySelectorAll(`.${select} .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && selectedItems && selectedItems.value) {
          title = `${label}: ${selectedItems.label}`;
          spans[0].innerHTML = title;
        }
      }
      this.handleFilterMyTopics(null);
    });
  };



  handleSearchChange = async (e) => {
    const value = e.target.value.trim();
    this.setState({ filterKeySearch: value });
  };

  handleFilter = async (event) => {
    if (event) {
      event.target.blur();
    }

    // Don't call getSessions for guide users - they should use getMySessions
    if (this.isUserGuide()) {
      return;
    }

    // Reset về page 1 khi filter thay đổi, sử dụng limit mặc định 12
    const params = this.buildFilterParams(this.state, 1);
    // Không cập nhật URL với page và limit - chỉ cập nhật các filter khác
    this.mapFilterToUrl(params);

    const { getSessions } = this.props;
    const sessions = await getSessions(params);
    if (this._isMounted && sessions.success) {
      const data = sessions.data.data;
      const listSessions = data.list || [];
      this.safeSetState({
        listSessions,
        currentPage: data.currentPage || 1,
        totalRecords: Number(data.total) || 0,
      });
    }
  };

  handleChangeDebounced = debounce(() => this.handleFilter(null), 500);

  handleSelect = (value, select, label) => {
    if (!value) {
      this.handleClearSelect(null, select);
      return;
    }
    this.safeSetState({ [select]: value }, () => {
      if (!this._isMounted) {
        return;
      }
      const selectedItems = this.state[select];
      let title = label;
      let element = document.querySelectorAll(`.${select} .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && selectedItems && selectedItems.value) {
          title = `${label}: ${selectedItems.label}`;
          spans[0].innerHTML = title;
        }
      }
    });
  };

  handleSelectMulti = (value, select, label) => {
    if (!value || !value.length) {
      this.handleClearSelect(null, select);
      return;
    }
    this.safeSetState({ [select]: value }, () => {
      if (!this._isMounted) {
        return;
      }
      // Use setTimeout to ensure DOM is ready before updating label
      this.createTimeout(() => {
        if (this._isMounted) {
          this.updateFilterLabel(select, label);
        }
      }, 0);
    });
  };

  handleClearSelect = (event, select) => {
    if (event) {
      event.target.blur();
    }
    this.safeSetState({ [select]: null }, () => {
      if (!this._isMounted) return;
      let element = document.querySelectorAll(`.${select}  .ant-select-selector label`);
      if (element.length) {
        element[0].remove();
      }
      element = null;
    });
  };

  updateFilterLabel = (select, label) => {
    const selectedItems = this.state[select];
    let title = label;
    let element = document.querySelectorAll(`.${select} .ant-select-selector`);
    if (element.length > 0 && element[0]) {
      let spans = element[0].querySelectorAll('label');
      if (spans.length) {
        spans.forEach(span => span.remove());
      }
      // Only add label if there are selected items
      // If selectedItems is null, undefined, empty array, or has no length, label will remain cleared
      if (selectedItems && selectedItems.length && selectedItems.length > 0) {
        // Special handling for language filter: show "Language: 2 choice" when 2 languages selected
        if ((select === 'filterLanguage' || select === 'filterLanguageMyTopics') && selectedItems.length === 2) {
          title = `${label}: 2 ${I18n.t('choice')}`;
        } else if (select === 'filterCategoryLevel2' || select === 'filterCategoryLevel2MyTopics') {
          title = `${label}: ${selectedItems.length} ${I18n.t('choice')}`;
        } else if (selectedItems.length > 1) {
          title = `${label}: ${selectedItems.length} ${I18n.t('choice')}`;
        } else {
          title = `${label}: ${selectedItems[0].label}`;
        }
        element[0].innerHTML += `<label>${title}</label>`;
      }
      // If no selected items, label is already cleared above, so placeholder will show
    }
  };

  handleSelectCreateDate = (value) => {
    if (!value) {
      this.handleClearSelectDate(null);
      return;
    }
    const state = { filterCreateDate: value }
    if (value.value !== 'other') {
      state.startDate = null
      state.endDate = null
    }
    this.safeSetState(state, () => {
      if (!this._isMounted) return;
      const { filterCreateDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          title = `${title}: ${filterCreateDate.label}`;
          spans[0].innerHTML = title;
        }
      }
    });
  };

  handleSelectCreateDateForPopularTopics = (value) => {
    if (!value) {
      this.handleClearSelectDate(null);
      return;
    }
    const state = { filterCreateDate: value }
    if (value.value !== 'other') {
      state.startDate = null
      state.endDate = null
    }
    this.safeSetState(state, () => {
      if (!this._isMounted) return;
      const { filterCreateDate } = this.state;
      let title = I18n.t('topic_creation_time');
      let element = document.querySelectorAll(`.createDatePopularTopics .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          title = `${title}: ${filterCreateDate.label}`;
          spans[0].innerHTML = title;
        }
      }
    });
  };

  handleSelectCreateDateMyTopics = (value) => {
    if (!value) {
      this.handleClearSelectDateMyTopics(null);
      return;
    }
    const state = { filterCreateDateMyTopics: value }
    if (value.value !== 'other') {
      state.startDateMyTopics = null
      state.endDateMyTopics = null
    }
    this.safeSetState(state, () => {
      if (!this._isMounted) return;
      const { filterCreateDateMyTopics } = this.state;
      let title = I18n.t('topic_creation_time');
      let element = document.querySelectorAll(`.createDateMyTopics .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDateMyTopics && filterCreateDateMyTopics.value) {
          title = `${title}: ${filterCreateDateMyTopics.label}`;
          spans[0].innerHTML = title;
        }
      }
      // Auto-submit filter when selecting a predefined date range (not "other")
      if (value.value !== 'other') {
        this.handleFilterMyTopics(null);
        this.safeSetState({ openFilterCreateDateMyTopics: false });
      }
    });
  };

  handleClearSelectDate = (event) => {
    if (event) {
      event.target.blur();
    }
    this.setState({
      filterCreateDate: null,
      startDate: null,
      endDate: null,
    });
  };

  handleClearSelectDateMyTopics = (event) => {
    if (event) {
      event.target.blur();
    }
    this.setState({
      filterCreateDateMyTopics: null,
      startDateMyTopics: null,
      endDateMyTopics: null,
    });
  };

  handleStartTime = (value) => {
    const endDate = this.state.endDate?.valueOf() || null;
    if (endDate && endDate < value?.valueOf()) {
      this.setState({ startDate: null })
      return
    }
    this.setState({ startDate: value }, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          if (this.isOther()) {
            if (startDate && endDate) {
              title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
            } else if (startDate) {
              title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
            } else if (endDate) {
              title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
            }
          } else {
            title = `${filterCreateDate.label}`;
          }
          spans[0].innerHTML = title;
          spans[0].setAttribute('title', title);
        }
      }
    })
  };

  handleStartTimeForPopularTopics = (value) => {
    const endDate = this.state.endDate?.valueOf() || null;
    if (endDate && endDate < value?.valueOf()) {
      this.setState({ startDate: null })
      return
    }
    this.setState({ startDate: value }, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('topic_creation_time');
      let element = document.querySelectorAll(`.createDatePopularTopics .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          if (this.isOther()) {
            if (startDate && endDate) {
              title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
            } else if (startDate) {
              title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
            } else if (endDate) {
              title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
            }
          } else {
            title = `${filterCreateDate.label}`;
          }
          spans[0].innerHTML = title;
          spans[0].setAttribute('title', title);
        }
      }
    })
  };

  handleStartTimeMyTopics = (value) => {
    const endDate = this.state.endDateMyTopics?.valueOf() || null;
    if (endDate && endDate < value?.valueOf()) {
      this.setState({ startDateMyTopics: null })
      return
    }
    this.setState({ startDateMyTopics: value }, () => {
      const { filterCreateDateMyTopics, startDateMyTopics, endDateMyTopics } = this.state;
      let title = I18n.t('topic_creation_time');
      let element = document.querySelectorAll(`.createDateMyTopics .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDateMyTopics && filterCreateDateMyTopics.value) {
          if (this.isOtherMyTopics()) {
            if (startDateMyTopics && endDateMyTopics) {
              title = `${title}: ${moment(startDateMyTopics).format('DD/MM/YY')} - ${moment(endDateMyTopics).format('DD/MM/YY')}`;
            } else if (startDateMyTopics) {
              title = `${I18n.t('date_from')} ${moment(startDateMyTopics).format('DD/MM/YY')}`;
            } else if (endDateMyTopics) {
              title = `${I18n.t('date_to')} ${moment(endDateMyTopics).format('DD/MM/YY')}`;
            }
          } else {
            title = `${title}: ${filterCreateDateMyTopics.label}`;
          }
          spans[0].innerHTML = title;
          spans[0].setAttribute('title', title);
        }
      }
      // Auto-submit filter when both start and end dates are selected in "other" mode
      if (this.isOtherMyTopics() && startDateMyTopics && endDateMyTopics) {
        this.handleFilterMyTopics(null);
        this.safeSetState({ openFilterCreateDateMyTopics: false });
      }
    })
  };

  handleEndTime = (value) => {
    const startDate = this.state.startDate?.valueOf() || null;
    if (startDate && value?.valueOf() < startDate) {
      this.setState({ endDate: null })
      return
    }
    this.setState({ endDate: value }, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          if (this.isOther()) {
            if (startDate && endDate) {
              title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
            } else if (startDate) {
              title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
            } else if (endDate) {
              title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
            }
          } else {
            title = `${title}: ${filterCreateDate.label}`;
          }
          spans[0].innerHTML = title;
          spans[0].setAttribute('title', title);
        }
      }
    })
  };

  handleEndTimeForPopularTopics = (value) => {
    const startDate = this.state.startDate?.valueOf() || null;
    if (startDate && value?.valueOf() < startDate) {
      this.setState({ endDate: null })
      return
    }
    this.setState({ endDate: value }, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('topic_creation_time');
      let element = document.querySelectorAll(`.createDatePopularTopics .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          if (this.isOther()) {
            if (startDate && endDate) {
              title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
            } else if (startDate) {
              title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
            } else if (endDate) {
              title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
            }
          } else {
            title = `${title}: ${filterCreateDate.label}`;
          }
          spans[0].innerHTML = title;
          spans[0].setAttribute('title', title);
        }
      }
    })
  };

  handleEndTimeMyTopics = (value) => {
    const startDate = this.state.startDateMyTopics?.valueOf() || null;
    if (startDate && value?.valueOf() < startDate) {
      this.setState({ endDateMyTopics: null })
      return
    }
    this.setState({ endDateMyTopics: value }, () => {
      const { filterCreateDateMyTopics, startDateMyTopics, endDateMyTopics } = this.state;
      let title = I18n.t('topic_creation_time');
      let element = document.querySelectorAll(`.createDateMyTopics .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDateMyTopics && filterCreateDateMyTopics.value) {
          if (this.isOtherMyTopics()) {
            if (startDateMyTopics && endDateMyTopics) {
              title = `${title}: ${moment(startDateMyTopics).format('DD/MM/YY')} - ${moment(endDateMyTopics).format('DD/MM/YY')}`;
            } else if (startDateMyTopics) {
              title = `${I18n.t('date_from')} ${moment(startDateMyTopics).format('DD/MM/YY')}`;
            } else if (endDateMyTopics) {
              title = `${I18n.t('date_to')} ${moment(endDateMyTopics).format('DD/MM/YY')}`;
            }
          } else {
            title = `${title}: ${filterCreateDateMyTopics.label}`;
          }
          spans[0].innerHTML = title;
          spans[0].setAttribute('title', title);
        }
      }
      // Auto-submit filter when both start and end dates are selected in "other" mode
      if (this.isOtherMyTopics() && startDateMyTopics && endDateMyTopics) {
        this.handleFilterMyTopics(null);
        this.safeSetState({ openFilterCreateDateMyTopics: false });
      }
    })
  };

  handleFilterDate = async (event) => {
    const { startDate, endDate } = this.state;
    if (this.isOther() && !startDate && !endDate) {
      await this.handleClearSelectDate(null)
    }
    await this.handleFilter(null)
    this.safeSetState({ openFilterCreateDate: false })
  };

  handleFilterDateMyTopics = async (event) => {
    const { startDateMyTopics, endDateMyTopics } = this.state;
    if (this.isOtherMyTopics() && !startDateMyTopics && !endDateMyTopics) {
      await this.handleClearSelectDateMyTopics(null)
    }
    await this.handleFilterMyTopics(null)
    this.safeSetState({ openFilterCreateDateMyTopics: false })
  };

  // My Sessions date handlers
  // My Sessions handlers (for guide user - Topic creation time filter)

  isOther = () => (this.state.filterCreateDate?.value === 'other')
  isOtherMyTopics = () => (this.state.filterCreateDateMyTopics?.value === 'other')

  // API already returns name in the correct language based on accept-language header
  // So we just use category.name directly
  getCategoryLabel = (category) => {
    return category?.name || '';
  }

  updateFilterLabelForPopularTopicsDate = () => {
    const { filterCreateDate, startDate, endDate } = this.state;
    let title = I18n.t('topic_creation_time');
    let element = document.querySelectorAll(`.createDatePopularTopics .ant-select-selector`);
    if (element.length > 0 && element[0]) {
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && filterCreateDate && filterCreateDate.value) {
        if (this.isOther()) {
          if (startDate && endDate) {
            title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
          } else if (startDate) {
            title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
          } else if (endDate) {
            title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
          }
        } else {
          title = `${title}: ${filterCreateDate.label}`;
        }
        spans[0].innerHTML = title;
        spans[0].setAttribute('title', title);
      } else if (spans.length) {
        // No selection, just show the label
        spans[0].innerHTML = title;
        spans[0].setAttribute('title', title);
      }
    }
  }

  handleDropdownVisibleChange = (open) => {
    this.createTimeout(() => {
      if (!this._isMounted) {
        return;
      }
      if (this.isOther() && !open) {
        return
      }
      this.safeSetState({ openFilterCreateDate: open });
    }, 0);
  };

  handleDropdownVisibleChangeMyTopics = (open) => {
    this.createTimeout(() => {
      if (!this._isMounted) {
        return;
      }
      if (this.isOtherMyTopics() && !open) {
        return
      }
      this.safeSetState({ openFilterCreateDateMyTopics: open });
    }, 0);
  };

  handleSelectCategoryLevel1 = (value, select, label) => {
    if (!value) {
      this.safeSetState({
        filterCategoryLevel1: null,
        filterCategoryLevel2: [],
        categoriesLevel2: [],
      }, () => {
        if (this._isMounted) {
          this.handleClearSelect(null, select);
        }
      });
      return;
    }

    const selectedCategory = this.state.categoriesWithChildren.find(cat => cat._id === value.value);

    if (selectedCategory && selectedCategory.children) {
      const allLevel2 = selectedCategory.children.map(child => ({
        key: child._id,
        value: child._id,
        label: this.getCategoryLabel(child),
      }));

      this.safeSetState({
        [select]: value,
        filterCategoryLevel2: allLevel2,
        categoriesLevel2: allLevel2
      }, () => {
        if (!this._isMounted) return;
        this.updateFilterLabel(select, label);
        if (allLevel2.length > 0) {
          this.createTimeout(() => {
            if (this._isMounted) {
              this.updateFilterLabel('filterCategoryLevel2', I18n.t('session_category_level2') || 'Sub Category');
            }
          }, 100);
        }
      });
    } else {
      this.safeSetState({
        [select]: value,
        filterCategoryLevel2: [],
        categoriesLevel2: []
      }, () => {
        if (!this._isMounted) return;
        this.updateFilterLabel(select, label);
      });
    }
  };

  renderSelect = ({ label, select, options, onChange, onFilter }) => {
    // Don't render Select if component is unmounted
    if (!this._isMounted) {
      return <div className={select} style={{ minHeight: '32px' }} />;
    }

    const selectedItems = this.state[select];
    const { currentI18nLanguage } = this.state;
    const handleChange = onChange || ((value) => {
      if (!this._isMounted) {
        return;
      }
      this.handleSelect(value, select, label);
    });
    const handleFilter = onFilter || this.handleFilter;

    // Create a ref callback to track Select instances
    const selectRef = (node) => {
      if (node && this._selectRefs) {
        // Always track refs, but check mounted status when using them
        if (this._selectRefs.indexOf(node) === -1) {
          this._selectRefs.push(node);
        }
      }
    };

    return (
      <Select
        ref={selectRef}
        key={`${select}-${currentI18nLanguage}`}
        className={select}
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        value={selectedItems}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        placeholder={label}
        onChange={handleChange}
        onDropdownVisibleChange={(open) => {
          // Early return if unmounted to prevent any state updates
          if (!this._isMounted) {
            return false;
          }
          // Allow the dropdown to open/close normally if mounted
        }}
        dropdownRender={menu => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options && options.length ? (<div className="mtp-dropdown-footer">
              <div className="d-flex">
                <button
                  onClick={(event) => {
                    if (!this._isMounted) {
                      event.preventDefault();
                      return;
                    }
                    this.handleClearSelect(event, select);
                  }}
                  className="clear-all"
                >
                  {I18n.t('clear_all')}
                </button>
                <button
                  onClick={(event) => {
                    if (!this._isMounted) {
                      event.preventDefault();
                      return;
                    }
                    handleFilter(event);
                  }}
                  className="apply"
                >
                  {I18n.t('apply')}
                </button>
              </div>
            </div>) : null}
          </>
        )}
        options={options}
      />
    );
  };

  renderSelectMulti = ({ label, select, options, onFilter }) => {
    // Don't render Select if component is unmounted
    if (!this._isMounted) {
      return <div className={select} style={{ minHeight: '32px' }} />;
    }

    const selectedItems = this.state[select];
    const { currentI18nLanguage } = this.state;
    const handleFilter = onFilter || this.handleFilter;
    // Re-compute label based on current language to ensure it's always up-to-date
    const currentLabel = typeof label === 'function' ? label() : label;

    // Create a ref callback to track Select instances
    const selectRef = (node) => {
      if (node && this._selectRefs) {
        // Always track refs, but check mounted status when using them
        if (this._selectRefs.indexOf(node) === -1) {
          this._selectRefs.push(node);
        }
      }
    };

    return (
      <Select
        ref={selectRef}
        key={`${select}-${currentI18nLanguage}`}
        className={select}
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        mode="multiple"
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={selectedItems}
        placeholder={currentLabel}
        onChange={(value) => {
          if (!this._isMounted) {
            return;
          }
          this.handleSelectMulti(value, select, currentLabel);
        }}
        onDropdownVisibleChange={(open) => {
          // Early return if unmounted to prevent any state updates
          if (!this._isMounted) {
            return false;
          }
          // Allow the dropdown to open/close normally if mounted
        }}
        dropdownRender={menu => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options && options.length ? (<div className="mtp-dropdown-footer">
              <div className="d-flex">
                <button
                  onClick={(event) => {
                    if (!this._isMounted) {
                      event.preventDefault();
                      return;
                    }
                    this.handleClearSelect(event, select);
                  }}
                  className="clear-all"
                >
                  {I18n.t('clear_all')}
                </button>
                <button
                  onClick={(event) => {
                    if (!this._isMounted) {
                      event.preventDefault();
                      return;
                    }
                    handleFilter(event);
                  }}
                  className="apply"
                >
                  {I18n.t('apply')}
                </button>
              </div>
            </div>) : null}
          </>
        )}
        options={options}
      />
    );
  };

  renderSelectDate = (options) => {
    // Don't render Select if component is unmounted
    if (!this._isMounted) {
      return <div className="createDate" style={{ minHeight: '32px' }} />;
    }

    const { filterCreateDate, openFilterCreateDate, startDate, endDate } = this.state;
    return (
      <Select
        className="createDate"
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        open={openFilterCreateDate}
        onDropdownVisibleChange={this.handleDropdownVisibleChange}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={filterCreateDate}
        placeholder={I18n.t('dashboard_filter_date')}
        onChange={this.handleSelectCreateDate}
        dropdownStyle={{ width: '350px' }}
        dropdownRender={menu => (
          <>
            <div className="mtpd-dropdown-menu">{menu}</div>
            {options && options.length ? (
              <div className="mtp-dropdown-footer">
                {this.isOther() && (
                  <ConfigProvider locale={locale}>
                    <div className="d-flex justify-content-center align-content-center">
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleStartTime}
                        value={startDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                      <div className="d-flex align-items-center mr-2 ml-2" style={{ color: '#9CA3AF', fontSize: '16px' }}>-</div>
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleEndTime}
                        value={endDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                    </div>
                  </ConfigProvider>
                )}
                <div className="d-flex">
                  <button
                    onClick={this.handleClearSelectDate}
                    className="clear-all">{I18n.t('clear_all')}
                  </button>
                  <button onClick={this.handleFilterDate} className="apply">{I18n.t('apply')}</button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };

  renderSelectDateForPopularTopics = (options) => {
    // Don't render Select if component is unmounted
    if (!this._isMounted) {
      return <div className="createDatePopularTopics" style={{ minHeight: '32px' }} />;
    }

    const { filterCreateDate, openFilterCreateDate, startDate, endDate, currentI18nLanguage, createDate } = this.state;
    return (
      <Select
        key={`createDatePopularTopics-${currentI18nLanguage}`}
        className="createDatePopularTopics"
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        open={openFilterCreateDate}
        onDropdownVisibleChange={this.handleDropdownVisibleChange}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={filterCreateDate}
        placeholder={I18n.t('topic_creation_time')}
        onChange={this.handleSelectCreateDateForPopularTopics}
        dropdownStyle={{ width: '350px' }}
        dropdownRender={menu => (
          <>
            <div className="mtpd-dropdown-menu">{menu}</div>
            {options && options.length ? (
              <div className="mtp-dropdown-footer">
                {this.isOther() && (
                  <ConfigProvider locale={locale}>
                    <div className="d-flex justify-content-center align-content-center">
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleStartTimeForPopularTopics}
                        value={startDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                      <div className="d-flex align-items-center mr-2 ml-2" style={{ color: '#9CA3AF', fontSize: '16px' }}>-</div>
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleEndTimeForPopularTopics}
                        value={endDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                    </div>
                  </ConfigProvider>
                )}
                <div className="d-flex">
                  <button
                    onClick={this.handleClearSelectDate}
                    className="clear-all">{I18n.t('clear_all')}
                  </button>
                  <button onClick={this.handleFilterDate} className="apply">{I18n.t('apply')}</button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };

  renderSelectDateMyTopics = (options) => {
    // Don't render Select if component is unmounted
    if (!this._isMounted) {
      return <div className="createDateMyTopics" style={{ minHeight: '32px' }} />;
    }

    const { filterCreateDateMyTopics, openFilterCreateDateMyTopics, startDateMyTopics, endDateMyTopics } = this.state;
    return (
      <Select
        className="createDateMyTopics"
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        open={openFilterCreateDateMyTopics}
        onDropdownVisibleChange={this.handleDropdownVisibleChangeMyTopics}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={filterCreateDateMyTopics}
        placeholder={I18n.t('topic_creation_time')}
        onChange={this.handleSelectCreateDateMyTopics}
        dropdownStyle={{ width: '350px' }}
        dropdownRender={menu => (
          <>
            <div className="mtpd-dropdown-menu">{menu}</div>
            {options && options.length ? (
              <div className="mtp-dropdown-footer">
                {this.isOtherMyTopics() && (
                  <ConfigProvider locale={locale}>
                    <div className="d-flex justify-content-center align-content-center">
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleStartTimeMyTopics}
                        value={startDateMyTopics}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                      <div className="d-flex align-items-center mr-2 ml-2" style={{ color: '#9CA3AF', fontSize: '16px' }}>-</div>
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleEndTimeMyTopics}
                        value={endDateMyTopics}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                    </div>
                  </ConfigProvider>
                )}
                <div className="d-flex">
                  <button
                    onClick={this.handleClearSelectDateMyTopics}
                    className="clear-all">{I18n.t('clear_all')}
                  </button>
                  <button onClick={this.handleFilterDateMyTopics} className="apply">{I18n.t('apply')}</button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };

  changeStandardTextColor = (e) => {
    e.target.style.color = '#00edc3';
  };
  changeRevertTextColor = (e) => {
    e.target.style.color = 'white';
  };

  checkStatusVerified = () => {
    if (user && user.statusVerify !== 'verified') {
      e.preventDefault();
    }
  };

  checkUserStatusVerify = () => {
    const { user } = this.props;
    if (!user?.name && !user?.statusVerify) {
      return 'verified';
    }
    return user.statusVerify ? user.statusVerify : 'need_to_verify';
  };

  getWarningTitle = () => {
    // return I18n.t('identity_rejected');
    const status = this.checkUserStatusVerify();
    if (status === 'need_to_verify') {
      return I18n.t('need_verify_identity');
    }
    if (status === 'verifying') {
      return I18n.t('verifying_identity');
    }
    if (status === 'reject') {
      return I18n.t('identity_rejected');
    }
    return '';
  };

  getWarningContent = () => {
    // return I18n.t('rejected_content');
    const status = this.checkUserStatusVerify();
    if (status === 'need_to_verify') {
      return I18n.t('verify_identity_warning');
    }
    if (status === 'verifying') {
      return I18n.t('verifying_content');
    }
    if (status === 'reject') {
      return I18n.t('rejected_content');
    }
    return '';
  };

  getVerifyButtonLabel = () => {
    // return I18n.t('verify_again');
    const status = this.checkUserStatusVerify();
    if (status === 'need_to_verify') {
      return I18n.t('verify_now');
    }
    if (status === 'verifying') {
      return I18n.t('verify_again');
    }
    if (status === 'reject') {
      return I18n.t('verify_again');
    }
    return '';
  };

  getVerifyIcon = () => {
    // return rejected;
    const status = this.checkUserStatusVerify();
    if (status === 'need_to_verify') {
      return unverified;
    }
    if (status === 'verifying') {
      return verifying;
    }
    if (status === 'reject') {
      return rejected;
    }

    return '';
  };

  getAlertBackgroundColor = () => {
    const status = this.checkUserStatusVerify();
    switch (status) {
      case 'need_to_verify':
        return '#FFFAEC';
      case 'verified':
        return '#f0f9ff';
      case 'verifying':
        return '#ECF4FF';
      case 'reject':
        return '#FFF5F6';
      default:
        return '#fefefe';
    }
  };

  isUserGuide = () => {
    const { user } = this.props;
    const userStorage = localStorage.getItem('ced:user-info');
    const userTypeFromState = user?.type || user?.mvpUserType;
    let userTypeFromStorage = null;
    if (userStorage) {
      try {
        const parsed = JSON.parse(userStorage);
        userTypeFromStorage = parsed?.type || parsed?.mvpUserType;
      } catch (e) {
        // ignore
      }
    }
    const currentUserType = userTypeFromState || userTypeFromStorage;
    return currentUserType === 'guide';
  };
}

const mapStateToProps = (state) => ({
  bounties: state.bounty,
  products: state.product,
  ui: state.ui,
  user: state.user,
  saleCampaigns: state.saleCampaign,
  listLanguage: state.mvp.listLanguage,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getSessions,
    getMySessions,
    getCategorySessions,
    getListBuddyRole,
    getMyTopics,
    getListDurationByLevel,
    fetchNeedEvaluateSessions,
    updatePageStatus,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Home);